var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded",class:[`aha-info--${_vm.variant}`]},[_c('div',{staticClass:"inline-flex p-2"},[_c('aha-icon',{staticClass:"flex-shrink-0 mr-1",class:[`aha-info-icon--${_vm.variant}`],attrs:{"name":"information"}}),_c('span',{staticClass:"text-xs text-base-90"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }